import { render, staticRenderFns } from "./file-view-container.vue?vue&type=template&id=23fc010c&scoped=true&"
import script from "./file-view-container.vue?vue&type=script&lang=js&"
export * from "./file-view-container.vue?vue&type=script&lang=js&"
import style0 from "./file-view-container.vue?vue&type=style&index=0&id=23fc010c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc010c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
